import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { LIMITTED_SUPPORTED_LANGUAGES_FOR_AGENTS } from '@/constants';
import InfoIcon from '@/images/Info.svg';
import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

const Paragraph = styled.span`
    color: ${theme.colors.secondary.main};
    font-size: 16px;
    line-height: 21.8px;
    font-weight: 500;
`;

const DocumentLanguageTipContainer = styled.div`
    display: flex;
    align-items: center;
    border-radius: 8px;
    gap: 8px;
    padding: 10px 16px;
    background-color: #ddf1ff;
`;

export const DocumentLanguageGuide = observer(() => {
    const agentEditorStore = useAgentEditorStore();

    const limitedLanguage = LIMITTED_SUPPORTED_LANGUAGES_FOR_AGENTS.find(
        lang => agentEditorStore.ttsSelectedLanguage?.split(' ')[0].toLowerCase() === lang.toLowerCase()
    );

    if (!limitedLanguage) return null;
    return (
        <DocumentLanguageTipContainer>
            <MaskedIcon src={InfoIcon} size="24px" color={'#054DA7'} />
            <Paragraph>
                The uploaded knowledge must match your Agent's language, which is {limitedLanguage}. Please ensure that all uploaded content
                is in {limitedLanguage}.
            </Paragraph>
        </DocumentLanguageTipContainer>
    );
});
